import * as angular from "angular";
import template from "./entity-customer-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import {
	All,
	Pattern
} from "../../../../services/security/actionScopes";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityCustomerTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	allTypeConfigs: EntityTypeConfig[];
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityCustomerTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canReadEntityCustomer = globs.entityTypes.byType(this.typeConfig.Code).customers.byType("*").read;
		const canReadCustomer = globs.customers.byType("*").read;
		const canViewCustomer = new All([
			new Pattern(canReadEntityCustomer),
			new Pattern(canReadCustomer)
		]);

		this.tab = {
			name: "Customer",
			code: "CUSTOMER",
			isAvailable: this.securityService.isActionScopeAllowed(canViewCustomer)
				&& !!this.typeConfig.Customers?.IsSupported
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-customer-tab", [])
	.component("entityCustomerTab", {
		controller: EntityCustomerTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			allTypeConfigs: "<",
			put: "=",
			post: "="
		}
	})
	.name;
